import PaginationContainer from "../../../Components/BonusUi/Pagination/PaginationContainer";

const Pagination = () => {
  return <PaginationContainer />;
};

export default Pagination;
